import React from 'react';
import { Link } from 'react-router-dom';

import emptyImage from '../../../../assets/images/empty-image.svg'

export default function Index(props) {

    if (props.items?.length === 0)
        return null;

    return (
        <div className='container mb-20'>
            <h2 className="pb-2 border-bottom mt-5">Ofertas</h2>
            <div className="row row-cols-1 row-cols-lg-3 align-items-stretch g-3 py-3">
                {
                    props.items?.map((item, index) => (
                        <div key={index} className='col-6 col-md-6 col-lg-3'>
                            <Link to={`/product-detail/${item.id}`} style={{ textDecoration: 'none' }}>
                                <div className='item-offert'>
                                    <img src={item.images?.leght === 0 ? emptyImage : item.images[0]} alt="" />
                                    <div className="item-offert-price">
                                        S/. {item.price.toFixed(2)}
                                    </div>
                                    {
                                        item.freeShipping ?
                                            <div className="item-offert-free">
                                                Envío gratis
                                            </div> : null
                                    }
                                    <div className='item-offert-label'>
                                        {item.name}
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))
                }
            </div>
        </div>
    );
}